import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { checkStoreAndUserType as checkStoreAndUserTypeAction } from 'ggApp/modules/auth/actions';
import SinglePageCheckout from './SinglePageCheckout';

const enhanced = connect(null, (dispatch) => ({
    checkStoreAndUserType: bindActionCreators(checkStoreAndUserTypeAction, dispatch),
}))(SinglePageCheckout);

export { enhanced as SinglePageCheckout };
